import { IChatRecord } from "../components/UI/Chat/AcxChatViewer";
import BaseService from "./BaseService";

export interface IMultiLanguageChatTranscriptionPayload {
    languageCode: string;
    chatTranscription: IChatRecord[];
}

export class ChatMediaService extends BaseService {
    protected urlBase: string = "api/ChatMedia";

    public async getChatMediaFile(
        amdId: string | undefined,
    ): Promise<IMultiLanguageChatTranscriptionPayload[]> {
        const res = await this.get<IMultiLanguageChatTranscriptionPayload[]>(
            new URLSearchParams({
                amdId: amdId as string,
            }),
            "ChatTranscriptionTextByAudioMetadata",
        );

        return res;
    }
}
